// Metallic slash, drawn locally without spell bubbles or external GFX.
export const BAZAR_AXE_SWEEP = 64000;
export const AXE_SWEEP_FRAMES = 6;
export function axeSweepPolygons(frame: number) {
  const head = -Math.PI / 2 + (frame / (AXE_SWEEP_FRAMES - 1)) * Math.PI * 2;
  const polygons: number[][] = [];
  for (let trail = 0; trail < 3; trail++) {
    const points: number[] = [];
    const end = head - trail * 0.22, span = 1.65 - trail * 0.2;
    for (let step = 0; step <= 16; step++) {
      const a = end - span + (step / 16) * span;
      points.push(Math.round(Math.cos(a) * (86 - trail * 5)), Math.round(Math.sin(a) * (40 - trail * 3)));
    }
    for (let step = 16; step >= 0; step--) {
      const a = end - span + (step / 16) * span;
      const thickness = Math.sin((step / 16) * Math.PI / 2) * (7 - trail);
      points.push(Math.round(Math.cos(a) * (86 - trail * 5 - thickness)), Math.round(Math.sin(a) * (40 - trail * 3 - thickness * 0.5)));
    }
    polygons.push(points);
  }
  return polygons;
}
